export default "__VITE_ASSET__d1f126c7__"